app.service('basketAnalyticsFilter', function (pageConfig, $global, price, front, broker) {

	function formattedName(name) {
		return name ? name.replaceAll('\u00A0', ' ').replaceAll('  ', ' ').trim() : '';
	}
	function formattedQuantity(quantity) {
		return parseInt(quantity || 1);
	}
	function formattedPrice(priceValue) {
		return priceValue ? price.number(priceValue) / 1 : 0;
	}
	function formattedPlu(plu) {
		return String(plu || '');
	}
	function formattedUrl(url) {
		const hostname = front.getParam('hostname');
		if (url.indexOf('http') !== 0) {
			return `${hostname}${url}`;
		}
		return url || '';
	}
	function getWarrantyData(warranty, product) {

		const getWarrantyType = (warrantyType) => {
			switch (warrantyType.toUpperCase()) {
				case 'POSTPONED':
					return 'TEN_TIMES';
				case 'ONE_TIME':
					return 'ONE_TIME';
				case 'SUBSCRIPTION':
					return 'SUBSCRIPTION';
				default:
					return '';
			}
		}
		const productData = findProductData({
			plu: product?.plu || warranty?.parentPlu
		});
		let data = {
			item_id: formattedPlu(warranty.id),									// ID grawancji
			price: formattedPrice(warranty.unitPrice || warranty.price),		// Cena grawancji
			item_variant: getWarrantyType(warranty.type), 						// Wariant grawancji
			item_name: formattedName(warranty.name) || '', 						// Nazwa grawancji
			item_list_name: 'Koszyk - Ubezpieczenia', 							// Szczegółowe miejsce dodania do koszyka
			item_list_id: 'cart_insurances', 									// Miejsce dodania do koszyka 
			quantity: formattedQuantity(warranty.quantity), 					// Ilość grawancji
			dimension31: 'Ubezpieczenie', 										// Kategoria dodawanego elementu
			dimension51: formattedPlu(productData?.ua.item_id),					// plu produktu, do którego przypisana jest gwarancja
			index: 0,
			item_category: productData?.ua.item_category,
			item_category2: productData?.ua.item_category2,
			item_category3: productData?.ua.item_category3,
		}
		return data;
	}
	function getDependentProductData(dependentProduct) {
		let data = {
			quantity: formattedQuantity(dependentProduct.quantity), 			// Ilość usług
			item_list_name: 'Koszyk - Akcesoria',								// na stałe
			item_list_id: 'cart_accessories',									// Miejsce dodania do koszyka
			dimension31: 'Towar',												// 
			dimension51: 'Dostępny',
			dimension44: 'IN_CHOSEN_SHOPS',										// PLU produktu, do którego przypisany jest produkt zależny
			item_name: formattedName(dependentProduct.name) || '',				// nazwa produktu
			item_id: formattedPlu(dependentProduct.code),						// numer PLU
			price: formattedPrice(dependentProduct.unitPrice)					// cena z uwzględnieniem przeceny!
		}
		return data;
	}
	function getServiceData(service, productDataUA) {
		let data = {
			item_name: formattedName(service.name) || '', 					// Nazwa usługi
			price: formattedPrice(service.price), 							// Cena usługi jest brana z danych analityki, nie z orderVar
			item_id: formattedPlu(service.code || service.plu), 			// PLU usługi
			item_category: productDataUA?.item_category, 					// 
			item_category2: productDataUA?.item_category2,					//	
			item_category3: productDataUA?.item_category3,					//
			item_variant: '', 												// TODO Wariant usługi
			index: 0, 														// nadpisywana wartość przed wysyłką
			quantity: formattedQuantity(service.quantity), 					// Ilość usług
			item_list_name: 'Koszyk - Usługi', 								// Szczegółowe miejsce dodania do koszyka
			item_list_id: 'cart_services', 									// Miejsce dodania do koszyka 
			dimension31: 'Usługa', 											// Kategoria dodawanego elementu
			dimension47: productDataUA?.dimension47,						//
			dimension51: formattedPlu(productDataUA?.item_id)				// plu produktu do którego jest ta usługa
		}
		return data;
	}
	function getPartnerSubscriptionData(partnerSubscription, params) {
		let data = {
			item_name: formattedName(partnerSubscription.name), 			// Nazwa usługi
			price: formattedPrice(partnerSubscription.unitPrice), 			// Cena usługi
			item_id: String(partnerSubscription.id), 						// ID usługi
			quantity: formattedQuantity(partnerSubscription.quantity), 		// Ilość usług
			item_list_name: 'Koszyk - Usługi partnerskie',					// Szczegółowe miejsce dodania do koszyka
			item_list_id: 'cart_partner_services', 							// Miejsce dodania do koszyka 
			item_variant: formattedName(partnerSubscription.name), 			// Wariant usługi
			dimension31: 'Usługa partnerska', 								// Kategoria dodawanego elementu: usługa
		}
		return Object.assign(data, params);
	}
	function getProductData(product, params) {
		let data = {
			//package_code: product.packageCode || '',		// ?? sam dodałem, kod zestawu, jeśli produkt jest częścią zestawu
			item_name: formattedName(product.name ? product.name : (product.nameInCart ? product.nameInCart.charAt(0).toUpperCase() + product.nameInCart.slice(1) : '')),	//nazwa produktu
			item_id: String(product.plu || product.code || ''),				// numer PLU
			price: formattedPrice(product.unitPrice || product.price || 0),	// cena z uwzględnieniem przeceny! 
			item_brand: product.brand || '', 								// marka   
			item_category: product.nodes?.[0]?.name || '',
			item_category2: product.nodes?.[1]?.name || '',
			item_category3: product.nodes?.[2]?.name || '',
			item_variant: product.variant || '',							// ??
			item_list_name: 'Koszyk - Główna lista',						// ??
			item_list_id: 'cart_main_list', 								// identyfikator listy produktowej (stała wartość)
			coupon: product.coupon || '',									// lista kodów rabatowych przypisanych do produktu, przekazywana jako string z kodami oddzielonymi znakiem "|", np. "KOD1|KOD2|KOD3"
			discount: product.oldUnitPrice && product.oldUnitPrice.length ? Math.abs(price.minus(product.unitPrice, product.oldUnitPrice)) : 0,			// wartość rabatu
			index: 0,														// pozycja na liście przesyłanych danych, nie w koszyku
			quantity: formattedQuantity(product.quantity),					// ??
			dimension31: 'Towar', 											// rodzaj produktu (Towar | Usługa | Ubezpieczenie) (wartość zmienna)
			dimension34: product.gradeCount || 0,							// liczba opinii
			dimension35: product.gradeValue || 0,							// ocena produktu (z gwiazdek)
			dimension44: product.deliveryStatus || '',						// status dostępności z KP, przekazanie informacji o opisie dostępności produktu online wyświetlanego na froncie
			dimension47: product.isInstalmentPrice ? 'Raty' : 'Gotówka',	// 	Gotowka|Raty - aktywna zakładka Gotówka|Raty -> stan do podania na K0 jak ustawiony na Koszyku
			//dimension50: [],		// etykieta - przekazanie informacji o etykiecie produktu, Nowość, Bestseller, Black Friday, itp. zgodnie z dostępnymi wersjami etykiet
			dimension51: 'Dostępny',										// Dostępny/ Niedostępny/Dostępny tylko w sklepie
			metric1: formattedPrice(product.oldUnitPrice || product.price),	// Oryginalna cena produktu bez zniżki (wartość zmienna)
			url: formattedUrl(product.url)									// link do produktu
		}

		return Object.assign(data, params);
	}

	// zwraca tablicę obiektów produktów spełniających kryteria wyszukiwania, każdy obiekt ma dwa pola: raw - surowe dane produktu z koszyka, ua - dane przetworzone do formatu analityki UA
	// brak danych zwraca false
	function findProductsData(filters) {
		const basket = pageConfig.getData('basket');
		const result = basket.items.filter(item => {
			return Object.keys(filters).every(key => item[key] == filters[key]);
		});
		if (result && result.length) {
			return result.map(item => {
				return {
					raw: item,
					ua: getProductData(item)
				}
			});
		} else {
			return false;
		}
	}

	// zwraca informacje o produkcie do analityki UA, wynik ma dwa pola: raw - surowe dane produktu z koszyka, ua - dane przetworzone do formatu analityki UA
	// brak danych zwraca false
	function findProductData(filters) {
		const basket = pageConfig.getData('basket');
		const result = basket.items.find(item => {
			return Object.keys(filters).every(key => item[key] == filters[key]);
		});
		if (result) {
			return {
				raw: result,
				ua: getProductData(result)
			}
		} else {
			return false;
		}
	}
	function findPartnerSubscriptionData(filters, partnerSubscriptionsFilters, data) {
		const productData = findProductData(filters);
		if (!productData) {
			return false;
		}
		const item = productData.raw.partnerSubscriptions.find(item => {
			return Object.keys(partnerSubscriptionsFilters).every(key => item[key] == partnerSubscriptionsFilters[key]);
		});
		return item ? {
			raw: item,
			ua: getPartnerSubscriptionData(item, data)
		} : false;
	}
	function findRelatedProductData(filters, relatedProductFilters) {
		const productData = findProductData(filters);
		if (!productData) {
			return false;
		}
		const item = productData.raw.relatedAccessory.find(item => {
			return Object.keys(relatedProductFilters).every(key => item[key] == relatedProductFilters[key]);
		});
		return item ? {
			raw: item,
			ua: getProductData(item, {
				// dimension15: productData.raw.plu
			})
		} : false;
	}
	function findServiceData(serviceFilters, productFilters, additionalData = {}) {

		const serviceData = findData(serviceFilters);
		if (!(serviceData && serviceData.length)) {
			return false;
		}

		const productData = findProductData(productFilters);
		if (!productData) {
			return false;
		}
		return {
			raw: serviceData[0].raw,
			ua: getServiceData(Object.assign(serviceData[0].raw, additionalData), productData.ua)
		}
	}
	function findServicesData(filters) {
		const productData = findProductData(filters);
		if (!productData) {
			return false;
		}
		const item = productData.raw.services.map(item => {
			return {
				raw: item,
				ua: getServiceData(item, productData.ua)
			}
		});
		if (item && item.length) {
			return item;
		} else {
			return false;
		}
	}

	function findDependentProductData(filters) {
		const productData = findProductData(filters);
		if (!productData) {
			return false;
		}
		return productData.raw && productData.raw.dependentProduct ? {
			raw: productData.raw.dependentProduct,
			ua: getDependentProductData(productData.raw.dependentProduct)
		} : false;

	}
	function findAccessoryData(filters) {
		return {
			name: 'Brak mechanuzmu do zbierania danych z warstwy'
		}
	}
	function findWarrantyData(filters) {	// tylko do znalezienia aktualnej
		const productData = findProductData(filters);
		if (!productData) {
			return false;
		}
		if (!productData.raw.warranty || !productData.raw.warranty[0]) {
			return false;
		}
		return {
			raw: productData.raw.warranty[0],
			ua: getWarrantyData(productData.raw.warranty[0], {
				plu: productData.raw.plu,
				name: productData.raw.name,
			})
		};

	}
	function all() {
		const result = [];
		const basket = pageConfig.getData('basket');
		basket.items.forEach(item => {
			const product = {
				raw: item,
				ua: getProductData(item)
			}
			result.push(getProductData(product.raw));
			product.raw.services.forEach(service => {
				result.push(getServiceData(service, product.ua));
			});
			product.raw.warranty.forEach(warranty => {
				result.push(getWarrantyData(warranty, product.raw));
			});
		});
		return result;
	}
	const analiticsData = [];
	function addData(data) {
		if (data && data.type) {
			analiticsData.unshift(data);
		}
	}

	broker.on('BEFORE_PAGE_CHANGE', function () {
		analiticsData.length = 0;
	});
	broker.on('REFRESH_BASKET_VIEW', function () {
		analiticsData.length = 0;
	});
	broker.on('SUBMIT_BASKET_VIEW', function () {
		analiticsData.length = 0;
	});

	function findData(filters) {
		const result = analiticsData.filter(item => {
			return Object.keys(filters).every(key => item[key] == filters[key]);
		});
		console.log('findData', result)
		if (result && result.length) {

			return result.map(item => {
				return {
					raw: item,
					ua: item.type == 'product' ? getProductData(item) : (item.type == 'service' ? getServiceData(item) : (item.type == 'warranty' ? getWarrantyData(item) : null))
				}
			});
		} else {
			return false;
		}
	}
	$global('addAnaliticsData', addData);
	$global('getAnaliticsData', function () {
		return [...analiticsData];
	});
	return {
		addData,
		findData,
		//setProductData,
		findProductData,
		getProductData,
		findPartnerSubscriptionData,
		findRelatedProductData,
		findServiceData,
		findServicesData,
		findDependentProductData,
		findAccessoryData,
		findWarrantyData,
		findProductsData,
		getWarrantyData,
		all
	};
});
